import { useMemo } from 'react';

function removeHtmlTags(htmlString: string | undefined) {
  if (!htmlString) {
    return String(htmlString);
  }
  const div = document.createElement('div');
  div.innerHTML = String(htmlString);
  return div.textContent || div.innerText || '';
}

/**
 * 現在のページのタイトルを設定します。
 *
 * `usePageTitle`フックは、指定された`pageTitle`を基に、
 * ドキュメントのタイトルを更新します。指定したタイトルが
 * 'コードF15 ODYSSEY 幸せの風吹く空への道しるべ'の場合はそのまま、それ以外の場合は、
 * 'コードF15 ODYSSEY 幸せの風吹く空への道しるべ - 'に指定したタイトルを追加した形式に
 * なります。
 *
 * useMemoフックを使用しているため、pageTitleが変更された
 * 時のみドキュメントのタイトルが更新されます。
 *
 * @param {string} pageTitle - 設定するページのタイトル
 *
 * @example
 * usePageTitle('チャプター1');
 * // ドキュメントのタイトルが 'コードF15 ODYSSEY 幸せの風吹く空への道しるべ - チャプター1' に設定されます
 *
 * usePageTitle('コードF15 ODYSSEY 幸せの風吹く空への道しるべ');
 * // ドキュメントのタイトルが 'コードF15 ODYSSEY 幸せの風吹く空への道しるべ' に設定されます
 */
export const usePageTitle = (pageTitle: string | undefined): void => {
  useMemo(() => {
    document.title = removeHtmlTags(pageTitle);
  }, [pageTitle]);
};
